export default __webpack_public_path__ + "static/media/finance.2a73a343.svg";